export default __webpack_public_path__ + "static/media/diners.49019e2a.svg";